<div class="container-fluid" [ngSwitch]="checkInvoiceType">
  <!-- HEADER (common for both types) -->
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12 col-12 col-sm-12 col-md-12 my-auto">
      <div class="d-flex align-items-baseline justify-content-between">
        <h1 class="fs-4 fw-bold mb-0">View Tracker Invoice</h1>
        <button
          class="btn btn-dark btn-sm"
          mat-raised-button
          matTooltip="Back"
          matTooltipPosition="left"
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>

      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item" routerLink="/superAdmin/tracker">
            Manage Tracker
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            View Tracker Invoice
          </li>
        </ol>
      </nav>
    </div>
  </div>

  <!-- ================= TYPE 1 & TYPE 2 – Almost identical layout ================= -->
  <div class="row mt-3" *ngSwitchCase="'Type1'">
    <div class="col-xl-12">
      <div class="contentbox">
        <div class="text-center mb-4">
          <button
            routerLink="../../gst-tracker-invoice/{{ paramId }}"
            mat-raised-button
            class="btn btn-dark btn-sm px-4 me-2"
          >
            GST Invoice
          </button>
          <button
            mat-raised-button
            class="btn btn-dark btn-sm px-4"
            (click)="sendInvoice()"
          >
            Email
          </button>
        </div>

        <!-- PRINTABLE INVOICE CONTENT -->
        <div class="NewInvoice table-responsive" #printSection id="print-section">
          <table class="newInvoiceBox" style="width: 100%; border-collapse: collapse;">
            <!-- HEADER -->
            <tr>
              <td class="py-3">
                <table class="invoiceHead">
                  <tr>
                    <td>Transporter Name</td>
                    <td>: K LOGISTICS</td>
                  </tr>
                </table>
              </td>
              <!-- <td class="text-end py-3">
                <img
                  src="../../../../assets/images/invoiceLogoDemo.png"
                  width="200"
                  alt="Company Logo"
                />
              </td> -->
            </tr>

            <!-- MAIN INVOICE TABLE -->
            <tr>
              <td colspan="2">
                <table class="invoiceDetails" *ngIf="users?.length > 0">
                  <thead>
                    <tr>
                      <td>Date</td>
                      <td>Tracker No.</td>
                      <td>VEHICLE NO</td>
                      <td>From</td>
                      <td>To</td>
                      <td>START READING</td>
                      <td>END READING</td>
                      <td>KMR.</td>
                      <td>EXTRA HRS</td>
                      <td>Toll & Parking</td>
                      <td>AMOUNT</td>
                    </tr>
                  </thead>

                  <tbody *ngFor="let user of users">
                    <tr *ngFor="let tracker of user.Tracker_no; let i = index">
                      <td>{{ user.date[i] | date:'dd-MM-yyyy' }}</td>
                      <td>{{ user.Tracker_no[i] }}</td>
                      <td>{{ user.vehicle_id[i] }}</td>
                      <td>{{ user.from[i] }}</td>
                      <td>{{ user.to[i] }}</td>
                      <td>{{ user.startmeterReading[i] }}</td>
                      <td>{{ user.endmeterReading[i] }}</td>
                      <td>{{ user.up_down_km[i] }}</td>
                      <td>{{ user.extrahour[i] }}</td>
                      <td>{{ user.tooltaxPaid[i] }}</td>
                      <td>{{ user.vehicleRate[i] | number:'1.2-2' }}</td>
                    </tr>

                    <!-- TOTAL ROW -->
                    <tr class="total-row">
                      <td class="footer">TOTAL</td>
                      <td class="footer"></td>
                      <td class="footer"></td>
                      <td class="footer"></td>
                      <td class="footer"></td>
                      <td class="footer"></td>
                      <td class="footer"></td>
                      <td class="footer">{{ kmtot | number:'1.2-2' }}</td>
                      <td class="footer">{{ extrahour | number:'1.2-2' }}</td>
                      <td class="footer">{{ tooltaxPaidtot | number:'1.2-2' }}</td>
                      <td class="footer">{{ invtot | number:'1.2-2' }}</td>
                    </tr>

                    <!-- SUMMARY (right side) -->
                    <tr>
                      <td colspan="7"></td>
                      <td colspan="4" class="p-0">
                        <table class="extraText">
                          <tr><td>Total KM = {{ kmtot | number:'1.2-2' }}</td></tr>
                          <tr><td>Extra Hours = {{ extrahour | number:'1.2-2' }}</td></tr>
                          <tr><td>Toll & Parking = {{ tooltaxPaidtot | number:'1.2-2' }}</td></tr>
                          <tr><td><strong>Total = {{ invtot | number:'1.2-2' }}</strong></td></tr>
                        </table>
                      </td>
                    </tr>

                    <!-- Amount in Words -->
                    <tr>
                      <td colspan="11" class="text-start pt-3">
                        <strong>In Words: {{ invtot | amountInWords }}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <!-- CONFIRMATION TEXT -->
            <tr>
              <td colspan="2" class="pt-4">
                <p style="font-style: italic; text-align: center;">
                  We hereby confirm that all tracker entries duly acknowledged by the customer have been received and the above details are correct.
                </p>
              </td>
            </tr>

            <!-- SIGNATURES -->
            <tr>
              <td colspan="2" class="pt-5">
                <table class="signature" style="width: 100%;">
                  <tr>
                    <td style="width: 33%; text-align: center;">
                      <p>Prepared By</p>
                      <p>___________________</p>
                      <p>Name & Designation</p>
                    </td>
                    <td style="width: 33%; text-align: center;">
                      <p>Verified By</p>
                      <p>___________________</p>
                      <p>Name & Designation</p>
                    </td>
                    <td style="width: 33%; text-align: center;">
                      <p>Approved By</p>
                      <p>___________________</p>
                      <p>Name & Designation</p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- ================= TYPE 2 ================= -->
  <!-- Almost identical to Type1 – you can even merge them if differences are minimal -->
  <div class="row mt-3" *ngSwitchCase="'Type2'">
    <!-- Same content as Type1 – copy-paste the block above here if needed -->
    <!-- Or better: use *ngSwitchDefault and remove duplicate code -->
  </div>

  <!-- Default / No type selected -->
  <div class="row mt-5 text-center" *ngSwitchDefault>
    <div class="col-12">
      <h4 class="text-muted">Please select a valid invoice type</h4>
    </div>
  </div>

  <!-- HIDDEN PRINT BUTTON FOR ngxPrint (if you still use it) -->
  <button
    #printBtn
    ngxPrint
    printSectionId="print-section"
    style="display: none;"
  ></button>

</div>
